<template>
  <div class="alert" v-if="alert">
    <el-alert
      title="错误提示的文案"
      type="error"
      close="hide"
      description="文字说明文字说明文字说明文字说明文字说明文字说明"
      show-icon>
    </el-alert>
  </div>
</template>
<style scoped>
  .alert {
    margin: 0 auto;
    display: block;
    left: 0;
    right: 0;
    z-index: 3000;
    position: fixed;
    top:50px;
    width:300px;
    padding: 10px;
    border-radius: 5px;
  }
</style>
<script>
  let timer  = null;
  export default {
    name: "AlertInfo",
    data() {
      return {
        title:'',
        des:'',
        type:'',
        alert:false
      };
    },
    mounted (){

    },
    created(){

    },
    methods: {

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/AlertInfo.vue